import React, { createContext, useContext, useState, ReactNode, useRef } from "react";
import { IDataTableContextType, View } from "./interface";
import { GridApi } from "ag-grid-community";
 
const DataTableContext = createContext<IDataTableContextType | undefined>(undefined);

interface IDataTableProviderProps {
  children: ReactNode;
}

export const DataTableProvider = ({ children }: IDataTableProviderProps) => {  
 
  const [TableView, setTableView] = useState<View>(View.Basic);

  const VIEW_FIELDS_REF = useRef<Record<View, Set<string>> | null>(null);
  const COLUMN_FIELDS_REF = useRef<Map<string, any> | null>(null);

  const [visibleColumnList, setVisibleColumnList] = useState<string[]>(VIEW_FIELDS_REF.current ? Array.from(VIEW_FIELDS_REF.current?.[TableView]) : []);
  const [hiddenColumnList, setHiddenColumnList] = useState<string[]>([]);


  const [columnVisible, setColumnVisible] = useState<string>(""); 
  const [columnHidden, setColumnHidden] = useState<string>("");  

  const [selectedRowCount, setSelectedRowCount] = useState<number>(0);

  const [gridApi, setGridApi] = useState<GridApi>();

  const columnWidthsRef = useRef<Map<string, number>>(new Map());
  
  const floatingFilterValueMap = useRef<Map<string, string>>(new Map());

  const isSelectAllActive = useRef<boolean>(false);
  const totalEntriesRef = useRef<number>(0);
  const fetchUrlRef = useRef<string>("");
  const queryParamsStringRef = useRef<string>("");
  const fetchUrlParamsRef = useRef<URLSearchParams>(new URLSearchParams());
  const primaryKeyRef = useRef<string>("");
  const selectedRowData = useRef<Map<string, any>>(new Map());
  const deSelectedRowData = useRef<Map<string, any>>(new Map());
  const ROW_HEIGHT_DEFAULT = 35;
  const ROW_HEIGHT_OPTION_PADDING_TOP = 4;
  const [rowHeight, setRowHeight] = useState<number>(ROW_HEIGHT_DEFAULT);
  const [maxContentHeight, setMaxContentHeight] = useState<number>(ROW_HEIGHT_DEFAULT - ROW_HEIGHT_OPTION_PADDING_TOP); // To account for padding
  return (
    <DataTableContext.Provider
      value={{
        TableView,
        setTableView,
        VIEW_FIELDS_REF,
        maxContentHeight,
        setMaxContentHeight,
        COLUMN_FIELDS_REF,
        visibleColumnList, 
        setVisibleColumnList, 
        hiddenColumnList, 
        setHiddenColumnList, 
        
    	  columnVisible,
        setColumnVisible,
        columnHidden,
        setColumnHidden,

        selectedRowCount,          
        setSelectedRowCount,       
        gridApi,
        setGridApi,
        columnWidthsRef,

        floatingFilterValueMap,

        isSelectAllActive,
        totalEntriesRef,
        fetchUrlRef,
        queryParamsStringRef,
        fetchUrlParamsRef,
        primaryKeyRef,
        selectedRowData,
        deSelectedRowData,
        rowHeight,
        setRowHeight,
        ROW_HEIGHT_DEFAULT,
        ROW_HEIGHT_OPTION_PADDING_TOP,
      }}
    >
      {children}
    </DataTableContext.Provider>
  );
};

export const useDataTableContext = () => {
  const context = useContext(DataTableContext);
  if (!context) throw new Error("useDataTableContext must be used within a DataTableProvider");
  return context;
};
